import { Icon } from '@natera/material/lib/icon'
import { Popover } from 'radix-ui'
import { cn } from '~/shared/lib/cn'
import { IconButton } from '~/shared/ui'

export function SearchFilter({
  searchQuery,
  setSearchQuery,
}: {
  searchQuery: string
  setSearchQuery: (searchQuery: string) => void
}) {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <IconButton
          container="medium"
          materialIcon="search"
          onClick={() => setSearchQuery(searchQuery)}
        />
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          align="end"
          asChild
        >
          <div className="relative h-12 w-[320px] overflow-hidden rounded-sm shadow-[0px_0.25px_3px_0px_rgba(0,0,0,0.04),0px_2.75px_9px_0px_rgba(0,0,0,0.19)]">
            <Icon
              children="search"
              className="text-content-high-emphasis absolute top-1/2 left-0 mr-2 ml-4 -translate-y-1/2"
            />
            <input
              className={cn(
                'bg-surface-lowest hover:bg-surface-low box-border h-full w-full border-none pr-4 pl-12 tracking-[0.15px] outline-none',
                {
                  'pr-12': searchQuery,
                },
              )}
              name="search"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              autoComplete="off"
            />
            {searchQuery && (
              <IconButton
                className="absolute top-1/2 right-0 mr-3 ml-1 -translate-y-1/2"
                size="medium"
                container="small"
                materialIcon="close"
                onClick={() => setSearchQuery('')}
              />
            )}
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  )
}
